import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  banks: [],
  branches: [],
  tillAccount: [],
  vaultAccount: [],
  financialDate: {},
  corporateDetails: {},
  institutionData: null,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
